import { InputTag } from 'mixs/base/input_mixin';
// const flatpickr = require('flatpickr/dist/flatpickr').default;
// console.log(flatpickr)
import flatpickr from 'flatpickr';
const Japanese = require("flatpickr/dist/l10n/ja.js").Japanese;

export class InputsDate extends InputTag {
  datePicker:      any; // FlatpickrInstance
  init(){
    super.init();
    this.listenMount([this.onMoutInputsDate])
  }
  onMoutInputsDate(){
    this.setDatePicker();
  }
  setDatePicker(){
    let options:Partial<any>          = this.datePickerOptions();
    this.datePicker      = flatpickr(this.dateInput(), options);
  }
  onChangeDate(selectedDates, dateStr, instance){
    this.dispatch({date: {value: dateStr}} );
  }
  datePickerOptions(){
    return {
      mode:   "single",
      wrap: false,
      locale: Japanese
    };
  }
  dateInput(): HTMLInputElement {
    return <HTMLInputElement>this.querySelector('input[data-type="date"]');
  }
}

riot.mixin("inputs.date", InputsDate as riot.TagMixin)
